import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[pasteNumbersOnly]'
})
export class PasteNumbersOnlyDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const pasted = event.clipboardData?.getData('text') || '';
    const cleaned = pasted.replace(/\D+/g, '');

    const input = this.el.nativeElement;
    input.value = cleaned;

    // Dispatch input event so Angular picks up the change
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
